<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 w-100">
        <div class="d-flex align-items-center gap-2">
          <h6 class="modal-title" i18n>Create Template</h6>
        </div>
        <div class="flex-fill"></div>

        <button class="btn btn-secondary-light" (click)="prevStep()" *ngIf="currentStep !== steps.SelectTemplate">
          <i class="far fa-arrow-left"></i> <ng-container i18n>Back</ng-container>
        </button>
        <button
          class="btn btn-secondary-info"
          (click)="nextStep()"
          [disabled]="isProcessing"
          *ngIf="currentStep !== steps.TemplateDetails"
        >
          <ng-container i18n>Next</ng-container>
          <i class="far fa-arrow-right ml-1 mr-0" *ngIf="!isProcessing"></i>
          <i class="far fa-spin fa-spinner ml-1 mr-0" *ngIf="isProcessing"></i>
        </button>
        <button class="btn btn-warning" *ngIf="currentStep === steps.PlaceFields" (click)="onPreview()">
          <i class="far fa-eye"></i> <ng-container i18n>Preview</ng-container>
        </button>
        <button class="btn btn-secondary-info" (click)="onSave()" *ngIf="currentStep === steps.TemplateDetails">
          <i class="fas fa-save"></i> <ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body p-0" #modalBody>
      <mat-stepper [linear]="true" #stepper class="m-3">
        <mat-step i18n-label label="Select Document" [state]="stepper.selectedIndex > 0 ? 'done' : 'number'">
          <ng-template matStepContent>
            <app-upload-template
              [form]="templateBasicForm"
              [isTypeEditable]="isTemplateTypeEditable"
            ></app-upload-template>
          </ng-template>
        </mat-step>
        <mat-step
          i18n-label
          label="Add Signer"
          [optional]="true"
          [state]="stepper.selectedIndex > 1 ? 'done' : 'number'"
        >
          <ng-template matStepContent>
            <div class="container-box p-3">
              <div class="bg-active2 p-3 rounded">
                <div class="d-grid gap-3 mb-3" style="grid-template-columns: 2fr 1fr">
                  <div class="d-flex align-items-end">
                    <div class="text-semi-bold">
                      <span class="badge badge-circle badge-light border text-md">3</span>
                      <ng-container i18n> Who will be signing the template?</ng-container>
                    </div>
                  </div>
                  <div class="d-flex align-items-end text-semi-bold" i18n>Signing Order</div>
                </div>
                <app-add-roles-form [form]="addSignersForm" [templateType]="templateType"></app-add-roles-form>
              </div>
            </div>
          </ng-template>
        </mat-step>
        <mat-step
          i18n-label
          label="Place Fields"
          [optional]="true"
          [state]="stepper.selectedIndex > 2 ? 'done' : 'number'"
        >
          <ng-template matStepContent>
            <app-place-fields-form
              #placeFieldsFormCom
              [showStep]="true"
              [form]="fieldsForm"
              [templateType]="templateType"
              [templateFileUrl]="mergedTemplateFileUrl"
              [roles]="roles"
              [style.height.px]="modalBody.offsetHeight - 90"
            ></app-place-fields-form>
          </ng-template>
        </mat-step>
        <mat-step i18n-label label="Template Details" [state]="stepper.selectedIndex > 3 ? 'done' : 'number'">
          <ng-template matStepContent>
            <div class="container-box p-3">
              <div class="text-semi-bold mb-4">
                <span class="badge badge-circle badge-light border text-md">5</span>
                <ng-container i18n> Finalize the details for this template.</ng-container>
              </div>
              <app-template-details-form [form]="templateDetailsForm"></app-template-details-form>
            </div>
          </ng-template>
        </mat-step>
        <ng-template matStepperIcon="done">
          <i class="cs-icon cs-icon-check2 text-xs"></i>
        </ng-template>
        <ng-template matStepperIcon="edit">
          <i class="cs-icon cs-icon-check2 text-xs"></i>
        </ng-template>
      </mat-stepper>
    </div>
  </div>
</div>
